import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventStepUp } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import EventBodyEntry from '../event-body-entry';
type StepUpEventBodyProps = {
  data: UserTimelineEventStepUp['data'];
};
const StepUpEventBody = t0 => {
  const $ = _c(19);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.stepUpEvent.kind"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = kind => {
      if (kind === "identity") {
        return t(_temp);
      }
      if (kind === "proof_of_ssn") {
        return t(_temp2);
      }
      if (kind === "proof_of_address") {
        return t(_temp3);
      }
      if (kind === "custom") {
        return t(_temp4);
      }
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getDocumentKindText = t2;
  let t3;
  if ($[3] !== data || $[4] !== getDocumentKindText) {
    let t4;
    if ($[6] !== getDocumentKindText) {
      t4 = t5 => {
        const {
          kind: kind_0
        } = t5;
        return getDocumentKindText(kind_0);
      };
      $[6] = getDocumentKindText;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = data.map(t4).join(", ");
    $[3] = data;
    $[4] = getDocumentKindText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const documents = t3;
  let t4;
  if ($[8] !== data.length) {
    t4 = $_3 => data.length === 1 ? $_3.documentRequestedOne : $_3.documentRequestedOther;
    $[8] = data.length;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== data.length || $[11] !== t || $[12] !== t4) {
    t5 = t(t4, {
      count: data.length
    });
    $[10] = data.length;
    $[11] = t;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <p className="text-label-2 text-primary mr-1">{t5}</p>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== documents || $[17] !== t6) {
    t7 = <div data-dd-privacy="mask"><EventBodyEntry iconColor="primary" content={<>{t6}{documents}</>} /></div>;
    $[16] = documents;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default StepUpEventBody;
function _temp($) {
  return $.identity;
}
function _temp2($_0) {
  return $_0.proofOfSsn;
}
function _temp3($_1) {
  return $_1.proofOfAddress;
}
function _temp4($_2) {
  return $_2.custom;
}